import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { removeScrollbar } from '@/styles/helpers';
import { Chip } from '@/components/UI/Chip/Chip';

export const Box = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 15px 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0;
  }
`;

export const Tabs = styled.div`
  ${removeScrollbar()}
  display: flex;
  overflow-x: auto;
  gap: 10px;
`;

export const Tab = styled(Chip)`
  &:first-child {
    margin-left: 15px;
  }

  &:last-child {
    margin-right: 15px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const Title = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;
